/**
 * agent_apply_controller.js — agent application dynamic field toggle (Stimulus).
 *
 * Element-scoped controller on the application form (data-controller="agent-apply").
 * The placement-type <select> carries data-action="change->agent-apply#toggle".
 * Shows the "position" field for a hardware/supply store counter, the "plan" field
 * for every other placement type, and hides both until a type is chosen — clearing
 * the hidden field's value so a switched-away answer is not submitted.
 *
 * Replaces static/js/agent_apply.js, which bound the toggle via getElementById at
 * parse time — fine on first load but not the project's Turbo-safe pattern. Stimulus
 * re-connects after each <body> swap and auto-removes the action listener on
 * disconnect; connect() runs toggle() once so the fields match the rendered value
 * (e.g. when the server re-renders the form with form_data after a validation error).
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
        static targets = ['select', 'position', 'plan'];

        connect() {
            this.toggle();
        }

        toggle() {
            var val = this.selectTarget.value;
            if (val === 'hardware_store') {
                this.positionTarget.style.display = '';
                this.planTarget.style.display = 'none';
                this.planTarget.querySelector('textarea').value = '';
            } else if (val) {
                this.positionTarget.style.display = 'none';
                this.planTarget.style.display = '';
                this.positionTarget.querySelector('input').value = '';
            } else {
                this.positionTarget.style.display = 'none';
                this.planTarget.style.display = 'none';
            }
        }
}
